
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "e8becbfc36271d4eec0a4c121976397372905d24",
  "nuxt": {
    "buildId": "5a4c3307-a8e5-48bc-aba9-a4f93e810a56"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
